var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentrodeCarga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80145 0.000384389H7.95635C8.16611 0.000384389 8.29696 0.174893 8.19258 0.314808L5.69643 3.66007C5.59205 3.79999 5.7234 3.9745 5.93266 3.9745H9.72684C9.95507 3.9745 10.0824 4.17783 9.94009 4.31506L4.13121 9.92009C3.94842 10.0961 3.58284 9.95699 3.65376 9.73828L4.63614 6.70821C4.67909 6.57598 4.54874 6.4476 4.37144 6.4476H0.273107C0.0633461 6.4476 -0.0680042 6.27271 0.0368762 6.13279L4.56572 0.104936C4.61466 0.0399756 4.70456 0 4.80195 0L4.80145 0.000384389Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrodeCarga);
export default __webpack_public_path__ + "static/media/centrodeCarga.e4fdc090c7207fde58c383f22c69144e.svg";
export { ForwardRef as ReactComponent };